import { ZohoCampaignStatus } from 'shared/src/domain/zoho/zoho-types';

const colors: Record<ZohoCampaignStatus, string> = {
  'Potential Opportunity': 'bg-rose-400',
  New: 'bg-pink-400',
  'Media Campaign Details': 'bg-fuchsia-400',
  'Avails/Plan Development': 'bg-purple-400',
  'Proposal Sent': 'bg-violet-400',
  'Book the Campaign': 'bg-indigo-400',
  'Traffic & Onboard': 'bg-blue-400',
  'Pixel Setup': 'bg-lightBlue-400',
  'Campaign is Live': 'bg-green-400',
  'Campaign is Paused': 'bg-teal-400',
  'Campaign Management & Reporting': 'bg-emerald-400',
  'Campaign Complete': 'bg-cyan-400',
  'Renew Campaign': 'bg-lime-400',
  'Closed (Lost)': 'bg-yellow-400',
  'Exit - Dev Only': 'bg-amber-400',
  'Campaign Approved to Launch': 'bg-orange-400',
  'Campaign Cancelled': 'bg-red-400',
  'Pixel Check': 'bg-warmGray-400',
  Potential: 'bg-trueGray-400'
};

export function getColorForZohoStage(stage: string | undefined): string {
  return colors[stage as ZohoCampaignStatus] ?? 'bg-gray-400';
}

export function getPerformanceBackground(performance: number, base = 1) {
  const top = base + base / 2; // 1.5 default
  const bottom = base - base / 2; // 0.5 default
  const range = top - bottom;

  if (range === 0) {
    // If base is 0, return middle color
    return colorScale[Math.floor(colorScale.length / 2)];
  }

  if (performance >= top) {
    return colorScale[0]; // First value in the array
  } else if (performance <= bottom) {
    return colorScale[colorScale.length - 1]; // Last value in the array
  } else {
    // Calculate the index proportional to the range
    const index = Math.round(((top - performance) / range) * (colorScale.length - 1));
    return colorScale[index];
  }
}

export function getPerformanceColor(performance: number, base = 1) {
  const top = base + base / 3;
  const bottom = base - base / 3;
  return performance > top || performance < bottom ? '#ffffff' : '#000000';
}

const colorScale = [
  '#A1740A',
  '#BA7D0B',
  '#D99606',
  '#ECAA0D',
  '#FBBF24',
  '#FCD34D',
  '#FDE68A',
  '#FEF3C7',
  '#FFFBEB',
  '#FFFFFF',
  '#F5F3FF',
  '#EDE9FE',
  '#DDD6FE',
  '#C4B5FD',
  '#A78BFA',
  '#8646F4',
  '#6D28D9',
  '#5B21B6',
  '#340B75'
];
